import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import persistReducer from 'redux-persist/es/persistReducer';
import { authReducer } from './auth/slice';
import { storesReducer } from './stores/slice';
import { reviewsReducer } from './reviews/slice';
import { cartReducer } from './cart/slice';
import { productsReducer } from './products/slice';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token', 'userInfo'],
};

export const store = configureStore({
  reducer: {
    auth: persistReducer(authPersistConfig, authReducer),
    stores: storesReducer,
    reviews: reviewsReducer,
    cart: cartReducer,
    products: productsReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
